import { SALE_STATUS } from '@/constants';
import type { PurchaseHistoryListItem } from '@/features/account/types';
import type { OrderInquiryResult } from '../types';

/**
 * OrderInquiryResult を PurchaseHistoryListItem に変換する
 * GfPurchaseHistoryDetail コンポーネントで表示するため
 */
export const toHistoryListItem = (result: OrderInquiryResult): PurchaseHistoryListItem => ({
  purchaseHistoryId: 0,
  orderId: result.orderId,
  orderDate: result.createdAt,
  estimatedDeliveryDate: result.estimatedDelivery,
  userName: result.shippingAddress.fullName,
  taxIncludedPrice: result.goodsSubtotal,
  originalTaxIncludedPrice: null,
  discountAmount: null,
  totalAmount: result.totalAmount,
  shippingFee: result.shippingFee,
  originalShippingFee: result.shippingFee,
  paymentMethod: result.paymentMethodLabel,
  paymentMethodLabel: result.paymentMethodLabel,
  customerInfo: {
    fullName: result.shippingAddress.fullName,
    kanaName: '',
    phone: '',
    zip: result.shippingAddress.zip,
    province: '',
    city: '',
    address1: result.shippingAddress.address1,
    address2: result.shippingAddress.address2 ?? '',
  },
  deliveryStatus: result.statusLabel,
  latestStatus: result.status,
  trackingNumber: result.trackingNumber ?? '',
  items: result.items.map((item, index) => ({
    id: index,
    workId: 0,
    workName: item.workName,
    productId: 0,
    productName: item.name,
    productDescription: '',
    selectedColorId: 0,
    selectedColorName: item.color,
    selectedSizeId: 0,
    selectedSizeName: item.size,
    subOrderId: item.subOrderId,
    productColor: item.color,
    productSize: item.size,
    productDetail: '',
    printMethod: item.printMethod,
    thumbnailUrl: item.imageUrl,
    previewImageUrl: item.imageUrl,
    basePrice: item.basePrice,
    subtotal: item.itemSubtotal,
    discountedSubtotal: item.discountedSubtotal,
    quantity: item.quantity,
    skuCode: item.skuCode,
    materials: [],
    prints: item.prints.map((p) => ({
      id: p.id,
      name: p.name,
      previewImageUrl: p.previewImageUrl,
      shareToken: p.shareToken ?? '',
      shareable: p.shareable,
    })),
    productSpecs: [],
    breakdownPrices: {
      基本料金: item.basePrice,
      ...(item.printPrice > 0 ? { 印刷代: item.printPrice } : {}),
    },
    userPrintId: 0,
    productType: item.productType,
    productSaleStatus: SALE_STATUS.onSale,
  })),
});
